<template>
  <v-chip
    :style="{ backgroundColor: `var(--v-${color}-light-base) !important` }"
    :color="color"
    :small="small"
    :close="close"
    :height="height"
    :label="label"
    class="snt-chip"
    outlined
    v-on="$listeners">
    <slot />
  </v-chip>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    height: {
      type: String,
      default: undefined
    },
    label: Boolean,
    small: Boolean,
    close: Boolean
  }
}
</script>

<style lang="scss" scoped>

</style>
